
import styles from "./Textarea.module.scss";


interface ITextarea {
  customHeader?: React.ReactElement;
  placeholder?: string;
}


const Textarea: React.FC<ITextarea> = ({
  customHeader,
  placeholder = ''
}) =>{
  return(
    <>
      <div className={styles.customHeader}>
        {customHeader && customHeader}
      </div>
      <textarea 
        placeholder={placeholder}
        className={styles.input}
      >
      </textarea>
    </>
  )
}
export default Textarea;